<template>
  <el-form :model="merchantForm" :rules="rules" label-width="100px" ref="merchantForm">
    <el-form-item label="商家名称" prop="name">
      <el-input v-model="merchantForm.name" placeholder="请输入商家名称,例如 XXXX舞蹈社 "/>
    </el-form-item>
    <el-form-item label="LOGO">
      <div style="display: flex">
        <el-upload
          class="avatar-uploader"
          action="upload/file"
          :show-file-list="false"
          :on-success="handleAvatarSuccess">
          <img v-if="merchantForm.logo" :src="merchantForm.logo" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
    </el-form-item>
    <el-form-item label="商家类型" required>
      <el-select v-model="merchantForm.merchantType" placeholder="请选择商家类型">
        <el-option
          v-for="item in typeList?typeList:[]"
          :key="item.type"
          :label="item.text"
          :value="item.type">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="商家业务类型">
      <el-select v-model="merchantForm.categoryType" placeholder="请选择业务类型">
        <el-option
          v-for="item in categoryList?categoryList:[]"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="商家地址" required>
      <el-col :span="6">
        <el-form-item>
          <el-select v-model="merchantForm.provinceId" placeholder="请选择省份" @change="selectProvince">
            <el-option
              v-for="item in provinces"
              :key="item.areaCode"
              :label="item.areaName"
              :value="item.areaId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6" style="margin-left: 1rem">
        <el-form-item>
          <el-select v-model="merchantForm.cityId" placeholder="请选择城市" @change="selectCity">
            <el-option
              v-for="item in cityList"
              :key="item.areaCode"
              :label="item.areaName"
              :value="item.areaId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6" style="margin-left: 1rem">
        <el-form-item >
        <el-select v-model="merchantForm.areaId" placeholder="请选择区域">
          <el-option
            v-for="item in areaList"
            :key="item.areaCode"
            :label="item.areaName"
            :value="item.areaId">
          </el-option>
        </el-select>
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item label="详细地址" prop="address">
      <el-input v-model="merchantForm.address" placeholder="具体到门牌号,方便顾客上门"/>
    </el-form-item>
    <el-form-item label="联系电话" prop="phone">
      <el-input v-model="merchantForm.phone" placeholder="请输入负责人的联系电话"/>
    </el-form-item>

    <el-form-item label="开业时间">
      <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="merchantForm.startDate"/>
    </el-form-item>
    <el-form-item label="营业时间">
      <el-col :span="6">
        <el-form-item>
          <el-time-picker placeholder="营业开始时间" value-format="HH:mm:ss" v-model="merchantForm.openTimeStart"/>
        </el-form-item>
      </el-col>
      <el-col :span="6" style="margin-left:6rem">
        <el-form-item>
          <el-time-picker placeholder="打烊时间"  value-format="HH:mm:ss" v-model="merchantForm.openTimeEnd"/>
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item size="large">
      <el-button type="primary" size="large" @click="save" style="width: 10rem">提交</el-button>
    </el-form-item>
  </el-form>

</template>

<script>
import {add, meta} from './merchantApi'

export default {
  name: 'add',
  data () {
    return {
      provinces: [],
      cityList: [],
      areaList: [],
      categoryList: [],
      typeList: [],
      merchantForm: {
        name: '',
        logo: null,
        provinceId: null,
        cityId: null,
        areaId: null,
        address: '',
        latitude: null,
        longitude: null,
        categoryType: null,
        phone: '',
        startDate: '',
        openTimeStart: '',
        openTimeEnd: '',
        openDays: '',
        merchantCategoryType: null,
        merchantType: null,
        licenceImage: null
      },
      rules: {
        name: [
          { required: true, message: '请输入商家名称', trigger: 'blur' }
        ],
        province: [
          { required: true, message: '请选择省份', trigger: ['change', 'blur'] }
        ],
        city: [
          { required: true, message: '请选择城市', trigger: ['change', 'blur'] }
        ],
        area: [
          { required: true, message: '请选择区域', trigger: ['change', 'blur'] }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getMeta()
  },
  methods: {

    getMeta () {
      const loading = this.$loading({
        lock: true,
        text: '获取信息中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      meta().then(rsp => {
        loading.close()
        const {code, message, result} = rsp
        if (code === 0) {
          const { provinces, merchantCategoryList, merchantTypeList } = result
          this.provinces = provinces
          this.cityList = []
          this.areaList = []
          this.typeList = merchantTypeList
          this.categoryList = merchantCategoryList
          this.reset()
        } else {
          this.$message.error(message)
        }
      })
    },
    selectProvince (province) {
      this.areaList = []
      this.merchantForm.cityId = null
      this.merchantForm.areaId = null
      for (let i = 0; i < this.provinces.length; i++) {
        const tempItem = this.provinces[i]
        if (tempItem.areaId === province) {
          this.cityList = tempItem.subList ? tempItem.subList : []
          return
        }
      }
      this.cityList = []
    },
    selectCity (city) {
      this.merchantForm.areaId = null
      for (let i = 0; i < this.cityList.length; i++) {
        const tempItem = this.cityList[i]
        if (tempItem.areaId === city) {
          this.areaList = tempItem.subList ? tempItem.subList : []
          return
        }
      }
      this.areaList = []
    },
    save () {
      console.log(this.merchantForm)
      this.$refs['merchantForm'].validate((valid) => {
        if (valid) {
          if (!this.merchantForm.provinceId || !this.merchantForm.cityId || !this.merchantForm.areaId) {
            this.$message.warning('请选择地址')
            return
          }
          if (this.merchantForm.merchantType === null) {
            this.$message.warning('请选择商家类型')
            return
          }
          const loading = this.$loading({
            lock: true,
            text: '保存中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          add(this.merchantForm).then(rsp => {
            loading.close()
            this.$emit('success')
          }).catch(() => {
            loading.close()
          })
        } else {
          return false
        }
      })
    },
    reset () {
      this.merchantForm = {
        name: '',
        logo: null,
        provinceId: null,
        cityId: null,
        areaId: null,
        address: '',
        latitude: null,
        longitude: null,
        categoryType: null,
        phone: '',
        startDate: '',
        openTimeStart: '',
        openTimeEnd: '',
        openDays: '',
        merchantType: null,
        merchantCategoryType: null,
        licenceImage: null
      }
    },

    handleAvatarSuccess (e) {
      if (!e) {
        this.$message.error('图片上传失败')
      } else {
        const { code } = e
        if (code === 0) {
          const { result } = e
          const { url } = result
          this.merchantForm.logo = url
        } else {
          const { message } = e
          this.$message.error(message)
        }
      }
    }

  }
}
</script>

<style scoped>
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/merchant/add.vue